module.exports = require('./helpers/bundle-url').getBundleURL('01RMl') + "qianyu-min.60ff98ad.jpg";